import { AxiosError } from 'axios';
import http from '../shared/HttpCommon';

export interface TrustpilotRefreshResponse {
  availableAt?: string;
}

export interface TrustpilotRefreshStatusResponse {
  used?: number;
  availableAt?: string | null;
}

export type TrustpilotRefreshError = AxiosError<{ data?: { availableAt?: string } }>;

const refreshTrustpilotData = async (monitoringId: string): Promise<TrustpilotRefreshResponse> => {
  const { data } = await http.post(`/trustpilot/refresh/${monitoringId}`, {});
  return data;
};

const getRefreshStatus = async (monitoringId: string): Promise<TrustpilotRefreshStatusResponse> => {
  const { data } = await http.get(`/trustpilot/refresh/${monitoringId}/status`);
  return data;
};

const TrustpilotService = {
  refreshTrustpilotData,
  getRefreshStatus,
};

export default TrustpilotService;
